import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent {
  editUser!: FormGroup;
  public isShowPassword: boolean = false;
  public isShowCPassword: boolean = false;
  public formData: any = new FormData;

  departmentData!: any[];
  public file!: File;
  public imagePath: any;
  public imageURL = GlobalService.imageURL;
  public profilePicture: any;
  isSelectedAll: boolean = false;

  public userType: any;
  managerAccessListArray: any[] = [];
  selectedAccessKeys: boolean[] = [];
  userAccessKeys: any[] = [];
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: any, private fb: FormBuilder, private spinner: NgxSpinnerService, private cd: ChangeDetectorRef,
    private appService: AppService, private userManagementService: UserManagementService, public dialogRef: MatDialogRef<EditUserComponent>,
    private commonService: CommonService, private userManagement: UserManagementService,) {
  }
  ngOnInit(): void {
    this.editUser = this.fb.group({
      'profile_picture': [''],
      'first_name': ['', Validators.required],
      'last_name': ['', Validators.required],
      'email': ['', Validators.required],
      'phone_number': ['', Validators.required],
      'password': [''],
      'confirm_password': [''],
      'department': [''],
    })
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    for (let [fkey, fvalue] of Object.entries(this.editUser.value)) {
      for (let [key, value] of Object.entries(this.dialogData.data)) {
        if (fkey == key && fkey != 'profile_picture') {
          this.editUser.get(fkey)?.setValue(value)
        }
      }
    }
    this.departmentList()
    if (this.dialogData) {
      this.userType = this.dialogData.user_type.toLocaleLowerCase()
      // this.userAccessKeys = JSON.parse(this.dialogData.data.access)
      if (this.dialogData?.data?.access) {
        this.userAccessKeys = JSON.parse(this.dialogData.data.access) || [];
      }
    }
    this.changeBackground()
    this.onGetManagerAccessDetailes()
  }

  onGetManagerAccessDetailes() {
    let data = {}
    this.userManagement.managerAccessDetails(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.managerAccessListArray = response.msg;
        this.selectedAccessKeys = this.managerAccessListArray.map(item => this.userAccessKeys.includes(item.access_key));
      }
    })
  }

  toggleSelectAll() {
    this.selectedAccessKeys = this.selectedAccessKeys.map(() => this.isSelectedAll);
  }

  changeBackground() {
    let img = new Image();
    // imgUrl is the property containing what user has typed in input
    img.src = this.imageURL + this.dialogData.data.profile_picture;
    img.onload = () => {
      this.profilePicture = img.src;
    }
    img.onerror = () => {
      this.profilePicture = "assets/images/icons/user.png"
    }
  }
  password(formGroup: FormGroup) {
    const password = formGroup.get('password')?.value;
    const confirmPassword = formGroup.get('confirm_password')?.value;
    if (password && confirmPassword) {
      return password === confirmPassword ? null : { passwordNotMatch: true };
    }
    else {
      return { passwordNotMatch: false }
    }
  }
  toggleShowPassword(value: any) {
    if (value == 'password') {
      this.isShowPassword = !this.isShowPassword
    }
    else {
      this.isShowCPassword = !this.isShowCPassword
    }
  }
  onChange(value: any) { }
  departmentList = (): void => {
    this.spinner.show();
    let obj = {}
    this.userManagementService.departmentListing(obj).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.departmentData = success.data;
          // this.initManager();
          // this.cd.markForCheck();
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    }
    );
  }

  onSubmit() {

    const selectedKeys = this.selectedAccessKeys
      .map((isSelected, index) => isSelected ? this.managerAccessListArray[index].access_key : null)
      .filter((value: string | null) => value !== null);

    if (this.dialogData.user_type == 'Manager') {
      let paramsData: any = {
        password: this.editUser.value.password,
        confirm_password: this.editUser.value.confirm_password,
      }
      const formData = new FormData();
      formData.append('manager_id', this.dialogData.data.manager_id);
      formData.append('email', this.editUser.value.email);
      formData.append('first_name', this.editUser.value.first_name);
      formData.append('last_name', this.editUser.value.last_name);
      formData.append('phone_number', this.editUser.value.phone_number);
      formData.append('department', JSON.stringify(this.editUser.value.department));
      formData.append('password', this.editUser.value.password);
      formData.append('confirm_password', this.editUser.value.confirm_password);
      formData.append('access', JSON.stringify(selectedKeys));
      if (this.imagePath) {
        formData.append('profile_picture', this.file);
      }
      this.spinner.show()
      this.userManagementService.editManager(formData).subscribe({
        next: (success: any) => {
          this.spinner.hide();
          if (success.status == 200) {
            this.appService.showToastMessage('success', success.msg)
            this.dialogRef.close({ user_type: 'manager' })
          }
        },
        error: (error: any) => {
          this.spinner.hide();
          this.commonService.handleError(error)
        }
      },);
    }
    else {
      this.spinner.show();
      const formData = new FormData();
      formData.append('employee_id', this.dialogData.data.employee_id);
      formData.append('email', this.editUser.value.email);
      formData.append('first_name', this.editUser.value.first_name);
      formData.append('last_name', this.editUser.value.last_name);
      formData.append('phone_number', this.editUser.value.phone_number);
      formData.append('department', JSON.stringify(this.editUser.value.department));
      formData.append('password', this.editUser.value.password);
      formData.append('confirm_password', this.editUser.value.confirm_password);
      if (this.imagePath) {
        formData.append('profile_picture', this.imagePath);
      }
      this.userManagementService.editEmployee(formData).subscribe((success: any) => {
        this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close({ user_type: 'employee' })
        }
      })
    }
  }
  isControlHasError(controlName: string, validationType: string,): boolean {
    return this.appService.isControlHasError(this.editUser, controlName, validationType)
  }
  onProfilePicChange(fileInput: any) {
    this.file = <File>fileInput.target.files[0];
    this.formData.append('profile_picture', this.file);

    // this.formData.append('profile_picture', this.file);

    // Show preview 
    var mimeType = this.file.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }
    
    var reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = (_event) => { 
      this.imagePath = reader.result;
      this.cd.markForCheck();
    }
  }
  onCancel() {
    this.dialogRef.close({ dasd: 'ASdas' })
  }
}


